import React from 'react';
import classnames from 'classnames';

import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: { flex: 1 },
  sideNav: {
    marginLeft: 0,
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(30)
    }
  },
  sideNavMini: {
    marginLeft: 0,
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(7.5)
    }
  },
  sideNavNone: {
    marginLeft: 0
  }
}));

interface LayoutProps {
  children?: React.ReactNode
  sideNav: boolean
  sideNavType?: string
  className: string | undefined
  bgColor: string
}

const Layout = (props: LayoutProps) => {
  const theme = useTheme();
  const classes = useStyles();
  const {
    children,
    sideNav,
    sideNavType = 'default',
    className,
    bgColor = theme.palette.background.default
  } = props;

  return (
    <div
      className={classnames(
        className,
        sideNav && sideNavType === 'mini' && classes.sideNavMini,
        sideNav && sideNavType === 'default' && classes.sideNav,
        sideNav && sideNavType === 'none' && classes.sideNavNone,
        classes.root
      )}
      style={{ backgroundColor: bgColor }}
    >
      {children}
    </div>
  );
};

export default Layout;
